/** JSON `type` field sent to React Native WebView via `postMessage` when the player taps Continue on the result screen. */
export const RN_EXIT_MESSAGE_TYPE = "GAME_COMPLETED" as const;
